import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const AddonsIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  style,
    ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path d="M6.94286 0.771429H0.771429V6.94286H6.94286V0.771429Z" stroke={color} strokeWidth="1.5" strokeLinejoin="round" />
    <Path d="M17.2286 11.0571H11.0571V17.2286H17.2286V11.0571Z" stroke={color} strokeWidth="1.5" strokeLinejoin="round" />
    <Path d="M3.85714 17.2286C5.56134 17.2286 6.94286 15.8471 6.94286 14.1429C6.94286 12.4387 5.56134 11.0571 3.85714 11.0571C2.15295 11.0571 0.771429 12.4387 0.771429 14.1429C0.771429 15.8471 2.15295 17.2286 3.85714 17.2286Z" stroke={color} strokeWidth="1.5" strokeLinejoin="round" />
    <Path d="M14.1429 6.94286C15.8471 6.94286 17.2286 5.56134 17.2286 3.85714C17.2286 2.15295 15.8471 0.771429 14.1429 0.771429C12.4387 0.771429 11.0571 2.15295 11.0571 3.85714C11.0571 5.56134 12.4387 6.94286 14.1429 6.94286Z" stroke={color} strokeWidth="1.5" strokeLinejoin="round" />
  </Svg>
);

AddonsIcon.displayName = 'AddonsIcon';
